import React from "react";
import { Row, Col, Glyphicon } from "react-bootstrap";
import Api from "js/utilities/fnapi-client";
import UserHandler from "js/utilities/user-handler";
import FontAwesome from "react-fontawesome";
import Checkbox from "js/components/account/account-form-checkbox";
import Amplitude from "../../utilities/amplitude";
import TextField from "./account-form-textfield";

export default React.createClass({

  getInitialState() {
    return {
      deleting: false,
      userError: "",
      roles: this.props.roles,
      processingRoles: []
    };
  },

  componentWillMount(){
    this.setRoleLogic(this.state.roles);
  },

  // @TODO Each of these little clickable permission toggle should probably be a component
  render: function() {
    return (
      <div key={this.props.key} className={"account-table-row user-row" + (this.state.expanded ? ' expanded' : '') + (this.state.roles.length === 0 ? " removed" : "") }>
        <div className="account-row-header">

          <div className="account-table-left">
            <span>{ this.props.email }</span>
          </div>

          <div className="account-table-right">

            <span>
              <Checkbox
                checked={this.state.roles.indexOf("VIEW") > -1}
                disabled={this.state.disabledRoles.indexOf("VIEW") > -1}
                processing={this.state.processingRoles.indexOf("VIEW") > -1}
                onClick={(e) => this.toggleRole('VIEW',e)}
              />
            </span>

            <span>
              <Checkbox
                checked={this.state.roles.indexOf("EDIT") > -1}
                disabled={this.state.disabledRoles.indexOf("EDIT") > -1}
                processing={this.state.processingRoles.indexOf("EDIT") > -1}
                onClick={(e) => this.toggleRole('EDIT',e)}
              />
            </span>

            {this.props.entityType === "company" &&
            <span>
              <Checkbox
                checked={this.state.roles.indexOf("ADMINISTER_USERS") > -1}
                disabled={this.state.disabledRoles.indexOf("ADMINISTER_USERS") > -1}
                processing={this.state.processingRoles.indexOf("ADMINISTER_USERS") > -1}
                onClick={(e) => this.toggleRole('ADMINISTER_USERS', e)}
              />
            </span>
            }

            <span>
              {this.props.email !== UserHandler.getUser().email &&
                <FontAwesome name="trash" className="account-toggle delete green" onClick={this.deleteRoles}/>
              }
            </span>

          </div>
        </div>

      </div>
    );
  },

  // Certain roles can't exist without others...
  // So, we're going to disable the ones that can't exist...
  // This feels super procedural, i'm certain there are better ways to do this
  setRoleLogic: function(roles){

    var disabledRoles = [];

    // Add some logic here....the current user's roles should always be disabled, you can't edit yourself
    if (this.props.email === UserHandler.getUser().email){
      disabledRoles = [
        "VIEW",
        "EDIT",
        "ADMINISTER_USERS",
      ]
    }

    // View is not set, view is the only role that can be changed...this actually shouldn't ever happen
    else if (this.state.roles.indexOf("VIEW") === -1){
      disabledRoles.push("EDIT");
      disabledRoles.push("ADMINISTER_USERS");
    }

    // Edit is not set, Administer Users cannot be changed
    else if (this.state.roles.indexOf("EDIT") === -1){
      disabledRoles.push("ADMINISTER_USERS");
    }

    // ADMINISTER_USERS *is* set, neither edit nor view can be changed
    else if (this.state.roles.indexOf("ADMINISTER_USERS") !== -1){
      disabledRoles.push("VIEW");
      disabledRoles.push("EDIT");
    }

    // Edit and View are both set, View cannot be changed without unsetting EDIT
    else if (this.state.roles.indexOf("EDIT") !== -1){
      disabledRoles.push("VIEW");
    }


    this.setState({
      roles: roles,
      disabledRoles: disabledRoles
    });
  },

  // The function actually triggered by either delete or toggle
  updateRoles: function(roles){

    // We're going to use a different endpoint for updating applications and companies
    var endpoint;
    if (this.props.entityType === 'company'){
      endpoint = 'account/user';
    }
    else {
      endpoint = 'application/' + this.props.appToken + '/user';
    }
    let payload = {
      roles: roles,
      email: this.props.email
    };

    // Post the roles and update the state on response
    Api.post(endpoint,payload).then( (response) => {

      // @TODO: Check  the response array and make sure it's the same as the requested array
      // For now, we're using the webservice response to build the state, which....if it works...is great
      this.setRoleLogic(response.data.roles);

      this.setState({
        "processingRoles": []
      });

    }).catch( (error) => {
      // this.setState({error: error.message});

      this.setState({
        "processingRoles": []
      });

      alert("Error: " + error.message);
    });
  },

  // Add or remove whatever role was clicked
  toggleRole: function(role, e){

    this.setState({
      "processingRoles": [role]
    });

    // Create a temporary array with the requested change
    var roles = this.state.roles;
    var index = roles.indexOf(role);
    if (index === -1) {
      roles.push(role);
    } else {
      roles.splice(index, 1);
    }

    // Lets send an alert and make sure they know they're deleting the user if no roles remain
    // If they don't confirm, get out of  here
    if (roles.length === 0){
      var result = confirm("If you remove all roles from a user they will be removed from your account, are you sure?");
      if (!result){
        return;
      }
    }

    return this.updateRoles(roles);
  },

  // Removes all roles
  deleteRoles: function(e){
    var result = confirm("Are you sure you want to remove "+ this.props.email +" from your account?");
    if (!result){
      return;
    }
    return this.updateRoles([]);
  },


});



// WEBPACK FOOTER //
// ./src/js/components/account/account-table-user-row.jsx